<div mdbModal #seleccionarClientesTipos="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title w-100 text-left" id="myModalLabel">
          Seleccionar tipos de clientes {{origen}}
        </h4>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="hide()">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="modal-body">
        <ng-container *ngIf="mode === 'SEARCH'">
          <div class="row" *ngIf="busquedaIniciada && data.length === 0">
            <div class="col">
              <a mdbBtn color="info" class="waves-light" mdbWavesEffect>
                No existen registros para el filtro seleccionado</a>
            </div>
          </div>

          <table class="table table-striped table-hover table-sm align-middle"
            *ngIf="busquedaIniciada && data.length > 0">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col" class="text-center">
                  <mdb-checkbox [checked]="false" (change)='checkAllChange($event)'>
                    <span> Descripción</span>
                  </mdb-checkbox>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let tipo of data">
                <td>
                  <mdb-checkbox [checked]="tipo.checked" (change)='checkTipo(tipo)'>
                    <span style="font-size: 1rem">
                      <!-- {{tipo.codigo}} -->
                      {{tipo.descripcion}}
                    </span>
                  </mdb-checkbox>
                </td>
                <!-- <td>{{tipo.descripcion}}</td> -->
              </tr>
            </tbody>
          </table>
        </ng-container>
        <ng-container *ngIf="mode === 'VIEW_SELECTED'">
          <table class="table table-striped table-hover table-sm align-middle">
            <thead class="grey lighten-2">
              <tr>
                <!-- <th scope="col" class="text-center">Código</th> -->
                <th scope="col" class="text-center">Descripción</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let tipo of selectedData">
                <td>
                  <mdb-checkbox [checked]="tipo.checked" (change)='checkTipo(tipo)'>
                    <span style="font-size: 1rem">
                      <!-- {{tipo.codigo}} -->
                      {{tipo.descripcion}}
                    </span>
                  </mdb-checkbox>
                </td>
                <!-- <td>{{tipo.descripcion}}</td> -->
              </tr>
            </tbody>
          </table>
        </ng-container>
      </div>
    </div>
  </div>
</div>
